import React from 'react';

function AboutPage() {

  return (
    <div className="scroll-menu">
      <h5 className="scroll-title" style={{color: "white"}} >about</h5>
      <p>Pop's Liquor Cabinet is a bar inventory management app for the spirits enthusiast.</p>
      <p>Easily add and update inventory, and make tasting notes for yourself as you enjoy your collection.</p>
    </div>

  )
}

export default AboutPage;